module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [(_vm.query.status) ? _c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("充值成功！")]), _vm._v(" "), _c('p', [_vm._v("真相搜索团队将尽快为您处理！")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/user/Success.png")
    }
  })]) : _c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("充值失败！")]), _vm._v(" "), _c('p', [_vm._v("真相搜索团队将尽快为您处理！")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/user/error.png")
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f521a73"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personal/ChargeResult.vue
// module id = 767
// module chunks = 1